const mockCardDetails = {
    status_time: Math.floor(Date.now() / 1000),
    "Health Stats": {
        extracting_data: true,
        data_rate: 0,
        card_healthy: true
    },
    "Card Info": {
        card_id: "atlas0",
        card_type: "atlas",
        carrier_sn: "0050",
        mb_sn: "0044",
        ldc_sn: "D01",
        rdc_sn: "D04",
        mb_state: 20,
        fpga_release_version: "4.0",
        fpga_timestamp: "03-09-2026 15:59:46",
        uB_sw_revision: "6884ff38",
        rng_interface_version: "1.2.9"
    },
    "Calibration Failure Metrics": {
        hg_mb_hm_failure_time: "0:10",
        hg_mb_hm_warning: 0,
        hg_mb_hm_error: 0,
        left_dc_adc_realign_count: 0,
        left_dc_hm_failure_time: "0:10",
        left_dc_hm_warning: 0,
        left_dc_hm_error: 0,
        left_dc_cal_count: 0,
        left_dc_pair0_gaussian_QF: 0.751362,
        left_dc_pair1_gaussian_QF: 0.845851,
        left_dc_pair0_gaussian_avg: -6,
        left_dc_pair0_gaussian_var: 857,
        left_dc_pair1_gaussian_avg: -2,
        left_dc_pair1_gaussian_var: 864,
        left_dc_GQF_collection_count: 10,
        left_dc_pair0_RCT_total_failures: 0,
        left_dc_pair1_RCT_total_failures: 0,
        left_dc_pair0_APT_total_failures: 0,
        left_dc_pair1_APT_total_failures: 0,
        right_dc_adc_realign_count: 0,
        right_dc_hm_failure_time: "0:10",
        right_dc_hm_warning: 0,
        right_dc_hm_error: 0,
        right_dc_cal_count: 0,
        right_dc_pair0_gaussian_QF: 0.661995,
        right_dc_pair1_gaussian_QF: 0.805839,
        right_dc_pair0_gaussian_avg: -3,
        right_dc_pair0_gaussian_var: 861,
        right_dc_pair1_gaussian_avg: -7,
        right_dc_pair1_gaussian_var: 854,
        right_dc_GQF_collection_count: 10,
        right_dc_pair0_RCT_total_failures: 0,
        right_dc_pair1_RCT_total_failures: 0,
        right_dc_pair0_APT_total_failures: 0,
        right_dc_pair1_APT_total_failures: 0
    },
    "Daughter Card Metrics": {
        left_dc_ch1_avg: 1,
        left_dc_ch2_avg: 5,
        left_dc_ch3_avg: 6,
        left_dc_ch4_avg: 1,
        left_dc_ch1_var: 244,
        left_dc_ch2_var: 322,
        left_dc_ch3_var: 346,
        left_dc_ch4_var: 304,
        left_dc_ch1_photocurrent: "0.865mA",
        left_dc_ch2_photocurrent: "1.040mA",
        left_dc_ch3_photocurrent: "1.050mA",
        left_dc_ch4_photocurrent: "0.915mA",
        left_dc_led_dac_setting: "67.58mA",
        left_dc_ch1_offset_dac_setting: 23442,
        left_dc_ch2_offset_dac_setting: 28031,
        left_dc_ch3_offset_dac_setting: 28299,
        left_dc_ch4_offset_dac_setting: 24782,
        left_dc_led_mon_current: "67.245mA",
        right_dc_ch1_avg: -1,
        right_dc_ch2_avg: -1,
        right_dc_ch3_avg: -2,
        right_dc_ch4_avg: -1,
        right_dc_ch1_var: 269,
        right_dc_ch2_var: 281,
        right_dc_ch3_var: 300,
        right_dc_ch4_var: 299,
        right_dc_ch1_photocurrent: "0.927mA",
        right_dc_ch2_photocurrent: "0.908mA",
        right_dc_ch3_photocurrent: "0.992mA",
        right_dc_ch4_photocurrent: "0.943mA",
        right_dc_led_dac_setting: "66.977mA",
        right_dc_ch1_offset_dac_setting: 25094,
        right_dc_ch2_offset_dac_setting: 24585,
        right_dc_ch3_offset_dac_setting: 26805,
        right_dc_ch4_offset_dac_setting: 25504,
        right_dc_led_mon_current: "67.565mA"
    },
    "Temperature/Voltage Metrics": {
        "QCA 12V Voltage": "12.171V",
        "QCA 3P3V Voltage": "3.291V",
        "QCA 12V Current": "460.000mA",
        "QCA 3P3V Current": "1186.000mA",
        "MB 1P8V Voltage": "1.801V",
        "MB 2P5V Voltage": "2.466V",
        "MB 2P5V Current": "316.000mA",
        "MB 3P3V Voltage": "3.293V",
        "MB 3P3V Current": "663.000mA",
        "MB 15V Voltage": "14.960V",
        "MB -50V Voltage": "49.218V",
        "QCA Temperature (deg. C)": "48.0°",
        "QCA Die Temperature (deg. C)": "64.2°",
        "MB Left LED Temperature (deg. C)": "40.6°",
        "MB Right LED Temperature (deg. C)": "36.7°",
        "Left DC Temperature (deg. C)": "48.8°",
        "Right DC Temperature (deg. C)": "39.1°"
    },
    "EEPROM Data": {
        "Board (QCA) Product Name": "Atlas",
        "Board (QCA) Part Number": "10-0020-400",
        "Board (QCA) Part Number Rev": "03",
        "Board (QCA) Part Number ECO": "N/A",
        "Board (QCA) Serial Number": "00050",
        "Board (QCA) Manufacturer": "Qrypt Incorporated",
        "Board (QCA) Mfg Date": "Mar 13, 2024",
        "FPGA Part Number": "10258",
        "FPGA Part Number Rev": "04",
        "FPGA Part Number ECO": "N/A",
        Checksum: "0x1B",
        "Carrier Part Number": "10-0067-400",
        "Carrier Part Number Rev": "03",
        "Carrier Part Number ECO": "N/A",
        "Carrier Serial Number": "0050",
        "Carrier Mfg Date": "Apr 27, 2023",
        "Carrier Checksum": "0xF2",
        "Atlas Mainboard Serial Number": "0044",
        "Atlas Left DC Serial Number": "D01",
        "Atlas Right DC Serial Number": "D04",
        "Daughtercards Installed": "2"
    }
};
export default mockCardDetails;
